module.exports = __webpack_public_path__ + "static/media/awesome.0d91948c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/awesome.gif
// module id = 865
// module chunks = 0